module.exports = __webpack_public_path__ + "static/img/glove_chanel.b0e57ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/colors/women/glove_chanel.png
// module id = pl9u
// module chunks = 0